<template>
    <MainPage @clickBack="clickBack()">
        <div class="max-w-456px m-auto mt-5 lg:mt-0">
            <div class="mx-4 lg:mx-0 px-4 py-4 lg:px-10 border border-a-brown-d7c7b8 rounded-14">
                <div class="pb-8 font-bold text-18 lg:text-20 text-a-brown-502314 text-center">{{lbl.contact.content_title}}</div>
                <ContactDetail
                    class="mb-6"
                    :title="lbl.contact.callcenter_title"
                    :operateHrs="lbl.contact.operateHrs9_24"
                    :tel="lbl.contact.tel1">
                </ContactDetail>
                <!-- <ContactDetail
                    class="mb-6"
                    :title="lbl.contact.callcenter_title"
                    :operateHrs="lbl.contact.operateHrs24_9"
                    :tel="lbl.contact.tel2">
                </ContactDetail> -->
                <hr class="border-t border-a-brown-e1d2bc">
                <div class="mt-5 mb-2.5 flex items-center justify-between text-14 lg:text-16">
                    <div>
                        <span class="text-a-brown-9f8273">{{lbl.contact.social_title}} : </span>
                        <span class="text-a-brown-502314">{{lbl.contact.social_burgerKingTh}}</span>
                    </div>
                    <div class="flex">
                        <a href="https://www.facebook.com/BurgerKingThailand">
                            <img class="w-6 mr-5" src="@/assets/login/Facebook.svg"/>
                        </a>
                        <a href="https://instagram.com/burgerkingthailand?igshid=YmMyMTA2M2Y=">
                            <img class="w-6" src="@/assets/login/instagram.svg"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </MainPage>
</template>
<script>
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import ContactDetail from "../component/ContactDetail.vue";
//mixins
import LocaleMixin from "@/mixin/LocaleMixin";
export default {
    name: "ContactUs",
    mixins: [LocaleMixin],
    components: {
        MainPage,
        ContactDetail,
    },
    methods: {
        clickBack: function() {
            this.$router.back();
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
